import React from 'react';
import { Box, Typography, Grid, Card, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Settings as SettingsIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';

export default function PipingInformation() {
    const navigate = useNavigate();

    return (
        <Box sx={{
            position: 'fixed',
            top: '60px',
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            backgroundColor: '#f5f5f5'
        }}>
            {/* Header */}
            <Box sx={{ backgroundColor: 'white', borderBottom: '1px solid #e0e0e0', p: 1.5, flexShrink: 0 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <IconButton onClick={() => navigate('/main')} edge="start">
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" fontWeight={600}>Piping Information</Typography>
                </Box>
            </Box>

            {/* Content */}
            <Box sx={{ p: 1.5 }}>
                <Grid container spacing={2}>
                    {/* General Torque Procedure Card */}
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            onClick={() => navigate('/piping/information/general-torque-procedure')}
                            sx={{
                                minHeight: 140,
                                cursor: 'pointer',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-3px)',
                                    boxShadow: 3,
                                    borderColor: '#00acc1',
                                },
                                '&:active': {
                                    transform: 'translateY(0)',
                                }
                            }}
                        >
                            <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Box sx={{
                                        width: 40,
                                        height: 40,
                                        backgroundColor: '#00acc1',
                                        borderRadius: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        flexShrink: 0
                                    }}>
                                        <SettingsIcon sx={{ fontSize: 24, color: 'white' }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                lineHeight: 1.2,
                                                color: '#333'
                                            }}
                                        >
                                            General Piping Torque Procedure
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                fontSize: '0.75rem',
                                                lineHeight: 1.2
                                            }}
                                        >
                                            Bolt tightening specs
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Status section */}
                                <Box sx={{ mt: 'auto' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                        Reference guide
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>

                    {/* ANSI Flange Specifications Card */}
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            onClick={() => navigate('/piping/information/flange-specifications')}
                            sx={{
                                minHeight: 140,
                                cursor: 'pointer',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-3px)',
                                    boxShadow: 3,
                                    borderColor: '#00acc1',
                                },
                                '&:active': {
                                    transform: 'translateY(0)',
                                }
                            }}
                        >
                            <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Box sx={{
                                        width: 40,
                                        height: 40,
                                        backgroundColor: '#00acc1',
                                        borderRadius: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        flexShrink: 0
                                    }}>
                                        <SettingsIcon sx={{ fontSize: 24, color: 'white' }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                lineHeight: 1.2,
                                                color: '#333'
                                            }}
                                        >
                                            ANSI Flange Specifications
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                fontSize: '0.75rem',
                                                lineHeight: 1.2
                                            }}
                                        >
                                            Flange bolt requirements
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Status section */}
                                <Box sx={{ mt: 'auto' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                        Reference guide
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>

                    {/* Piping General Testing Card */}
                    <Grid item xs={12} sm={6} md={4} lg={3}>
                        <Card
                            onClick={() => navigate('/piping/information/piping-general-testing')}
                            sx={{
                                minHeight: 140,
                                cursor: 'pointer',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                backgroundColor: 'background.paper',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    transform: 'translateY(-3px)',
                                    boxShadow: 3,
                                    borderColor: '#00acc1',
                                },
                                '&:active': {
                                    transform: 'translateY(0)',
                                }
                            }}
                        >
                            <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                    <Box sx={{
                                        width: 40,
                                        height: 40,
                                        backgroundColor: '#00acc1',
                                        borderRadius: 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        mr: 2,
                                        flexShrink: 0
                                    }}>
                                        <SettingsIcon sx={{ fontSize: 24, color: 'white' }} />
                                    </Box>
                                    <Box sx={{ flex: 1 }}>
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 600,
                                                fontSize: '1rem',
                                                lineHeight: 1.2,
                                                color: '#333'
                                            }}
                                        >
                                            Piping, General Testing
                                        </Typography>
                                        <Typography
                                            variant="caption"
                                            color="text.secondary"
                                            sx={{
                                                fontSize: '0.75rem',
                                                lineHeight: 1.2
                                            }}
                                        >
                                            Testing specifications
                                        </Typography>
                                    </Box>
                                </Box>

                                {/* Status section */}
                                <Box sx={{ mt: 'auto' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                                        Reference guide
                                    </Typography>
                                </Box>
                            </Box>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
